const KNOWN_EMAIL_DOMAINS = [
  'gmail.com',
  'hotmail.com',
  'hotmail.es',
  'outlook.com',
  'outlook.es',
  'yahoo.com',
  'yahoo.es',
  'live.com',
  'icloud.com',
];

const MAX_TYPO_DISTANCE = 2;

function levenshteinDistance(a, b) {
  const rows = a.length + 1;
  const cols = b.length + 1;
  const distances = Array.from({ length: rows }, (_, i) => [i, ...new Array(cols - 1).fill(0)]);
  distances[0] = Array.from({ length: cols }, (_, j) => j);

  for (let i = 1; i < rows; i += 1) {
    for (let j = 1; j < cols; j += 1) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      distances[i][j] = Math.min(
        distances[i - 1][j] + 1,
        distances[i][j - 1] + 1,
        distances[i - 1][j - 1] + cost,
      );
    }
  }

  return distances[rows - 1][cols - 1];
}

// eslint-disable-next-line import/prefer-default-export
export const isLikelyTypoDomain = (email) => {
  if (!email || !email.includes('@')) return false;

  const domain = email.split('@').pop().trim().toLowerCase();
  if (KNOWN_EMAIL_DOMAINS.includes(domain)) return false;

  return KNOWN_EMAIL_DOMAINS.some((knownDomain) => {
    const distance = levenshteinDistance(domain, knownDomain);
    return distance > 0 && distance <= MAX_TYPO_DISTANCE;
  });
};
